import { Page } from '.';

export class Event {
    title: string; // required, character limit: 45
    description: string; // not required, character limit: 500
    startDateTime: Date; // required, format: MM/DD/YY at HH:MMam/pm
    endDateTime: Date; // required, format: MM/DD/YY at HH:MMam/pm
    allDay: boolean = false;
    streetAddress: string; // not required
    city: string; // not required
    state: string; // not required, two letter abbreviation
    zipCode: number; // limit 5 digits
    image: URL; // not required
    url: string; // not required
    label: string; // not required
    createdAt: string;
    updatedAt: string;

    targetID: string;
    targetPage: Page; // not required
    firebaseUrl: string = '';

    testID: string = '';

    constructor(json: any) {
      this.updateWithJson(json);
      this.generateDynamicId();
    }

    updateWithJson(json: any) {
      this.title = json.title || '';
      this.description = json.description || '';
      this.startDateTime = json.start_date || '';
      this.endDateTime = json.end_date || '';
      this.allDay = json.all_day || false;
      this.streetAddress = json.street_address || '';
      this.city = json.city || '';
      this.state = json.state || '';
      this.zipCode = json.zip_code || '';
      this.image = json.image || '';
      this.url = json.url || '';
      this.targetID = json.target_page || null;
      this.label = json.label || '';
      this.firebaseUrl = '/' + json.$key;
      this.createdAt = json.created_at || '';
      this.updatedAt = json.updated_at || '';
    }

    getAddressString() {
      let string = this.streetAddress;
      if (this.city) string += ', ' + this.city;
      if (this.state) string += ', ' + this.state;
      if (this.zipCode) string += ' ' + this.zipCode;
      while (string.indexOf(', ') === 0) {
        string = string.substr(2);
      }
      return string;
    }

    toFirebaseObject(): any {
      let obj: any = {};

      if (this.title) obj.title = this.title;
      if (this.description) obj.description = this.description;
      if (this.startDateTime) obj.start_date = this.startDateTime;
      if (this.endDateTime) obj.end_date = this.endDateTime;
      obj.all_day = this.allDay;
      if (this.streetAddress) obj.street_address = this.streetAddress;
      if (this.city) obj.city = this.city;
      if (this.state) obj.state = this.state;
      if (this.zipCode) obj.zip_code = this.zipCode;
      if (this.image) obj.image = this.image;
      if (this.url) obj.url = this.url;
      if (this.targetID) obj.target_page = this.targetID;
      if (this.label) obj.label = this.label;
      if (this.firebaseUrl) obj.firebase_url = this.firebaseUrl;
      if (this.createdAt) obj.created_at = this.createdAt;
      if (this.updatedAt) obj.updated_at = this.updatedAt;

      return obj;
    }

  generateDynamicId() {
    let validId = this.title;
    validId = validId.replace(/\s+/g, '-');
    validId = validId.replace(/[^a-z0-9\-_\.]|^[^a-z]+/gi, '');
    this.testID = 'cal-' + validId;
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/event.model.ts